(() => {
  if (window.SuperbiaDrawerMOQ) return;
  const root = () => document.querySelector('#halo-cart-sidebar');
  const rows = () => [...(root()?.querySelectorAll('[data-cart-moq-line]') || [])];
  const watchedModals = new WeakSet();
  let frame;

  function sync() {
    for (const marker of rows()) {
      const input = marker.closest('[data-item-row]')?.querySelector('[data-cart-quantity]');
      const warning = marker.querySelector('[data-cart-moq-warning]');
      if (!input || !warning) continue;
      const quantity = Number(input.value);
      const minimum = Number(marker.dataset.minimum);
      const invalid = !Number.isInteger(quantity) || quantity < minimum;
      // Quantity zero is Ella's remove-line action, not an MOQ warning.
      if (invalid && quantity !== 0) {
        const text = 'You must select at least ' + minimum + ' products';
        const changed = warning.hidden || warning.textContent !== text;
        if (warning.textContent !== text) warning.textContent = text;
        warning.hidden = false;
        if (changed && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          warning.animate?.([{transform: 'translateY(0)'}, {transform: 'translateY(-5px)'},
            {transform: 'translateY(0)'}, {transform: 'translateY(-2px)'},
            {transform: 'translateY(0)'}], {duration: 420, easing: 'ease-out'});
        }
      } else if (!warning.hidden) warning.hidden = true;
    }
    const order = root()?.querySelector('[data-drawer-order-minimum]');
    if (order) {
      const savedTotal = root().querySelector('[data-cart-total-value]')?.dataset.cartTotalValue;
      const total = Number(savedTotal ?? order.dataset.total);
      order.hidden = order.dataset.currency !== 'GBP' || !Number.isFinite(total) || total >= 10000;
    }
    replaceVendorWarnings();
  }

  function replaceVendorWarnings() {
    const list = document.querySelector('#purchase_limit_messages');
    if (!list) return;
    // The access gate replaces the full-cart markup, so cart-moq.js cannot handle its popup.
    const gatedCart = /(?:^|\/)cart\/?$/.test(location.pathname) && !document.querySelector('#main-cart-items');
    // Full-cart behavior belongs to cart-moq.js, including its GBP100 guard.
    if (document.querySelector('#main-cart-items') || (!gatedCart && !document.body.classList.contains('cart-sidebar-show'))) {
      for (const li of list.querySelectorAll('[data-drawer-moq-replaced]')) {
        delete li.dataset.drawerMoqReplaced;
        if (!li.hasAttribute('data-cart-moq-replaced')) li.hidden = false;
      }
      return;
    }
    const normal = text => text.replace(/\s+/g, ' ').trim().toLowerCase();
    let replaced = false;
    let remaining = false;
    for (const li of list.querySelectorAll('li')) {
      const text = normal(li.textContent);
      const matched = rows().some(marker => {
        const prefix = 'you need to purchase at least ' + marker.dataset.minimum + ' qty of ';
        const option = normal(marker.dataset.option);
        return text.startsWith(prefix + normal(marker.dataset.title)) &&
          (option === 'default title' || text.includes(' - ' + option));
      });
      const gatedOrder = gatedCart && /^the total order amount must be at least\s*£\s*100(?:\.0+)?\s*\.?$/.test(text);
      if (matched || gatedOrder) {
        replaced = true;
        li.dataset.drawerMoqReplaced = '';
        li.hidden = true;
      } else {
        if (li.hasAttribute('data-drawer-moq-replaced')) {
          delete li.dataset.drawerMoqReplaced;
          li.hidden = false;
        }
        if (text) remaining = true;
      }
    }
    const modal = list.closest('.modal-custom') || document.querySelector('#myModal');
    if (!modal) return;
    if (!watchedModals.has(modal)) {
      watchedModals.add(modal);
      new MutationObserver(schedule).observe(modal, {attributes: true, attributeFilter: ['style']});
    }
    // Preserve all other amount, maximum, stock and unrecognized errors.
    if (replaced && !remaining && modal.style.display !== 'none') modal.style.display = 'none';
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(() => {frame = null; sync();});
  }

  for (const name of ['input', 'change']) {
    document.addEventListener(name, event => {
      if (root()?.contains(event.target) && event.target.matches('[data-cart-quantity]')) sync();
    }, true);
  }
  document.addEventListener('click', event => {
    if (root()?.contains(event.target) && event.target.closest('.btn-quantity')) {
      // Ella updates value in its target handler, then waits 350ms to save it.
      schedule();
    }
  }, true);
  document.addEventListener('click', event => {
    if (root()?.contains(event.target) && event.target.closest('.btn-quantity')) sync();
  });
  document.addEventListener('cart-update', sync);
  new MutationObserver(schedule).observe(document.documentElement, {childList: true, subtree: true});
  new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class']});
  window.SuperbiaDrawerMOQ = {refresh: sync};
  sync();
})();
